module.exports = __webpack_public_path__ + "img/map.06b29747.png";